export const PERK_TYPES = [
  {
    id: "success",
    label: "Success",
    icon: "/assets/imgs/perks/category/success.png",
    property: "arrow-up",
  },
  {
    id: "cooldown",
    label: "Cooldown",
    icon: "/assets/imgs/perks/category/cooldown.png",
    property: "arrow-down",
  },
  {
    id: "booster",
    label: "Booster",
    icon: "/assets/imgs/perks/category/booster.png",
    property: "arrow-up",
  },
  {
    id: "tools",
    label: "Tools",
    icon: "/assets/imgs/perks/category/tools.png",
    property: "",
  },
];

export const PERK_OPTIONS: Record<
  string,
  {
    id: string;
    label: string;
    icon: string;
    property?: string;
  }[]
> = {
  success: [
    {
      id: "Crime",
      label: "Crime",
      icon: "/assets/imgs/perks/options/crime.png",
    },
    {
      id: "NickCar",
      label: "Nick a car",
      icon: "/assets/imgs/perks/options/nickcar.png",
    },
    {
      id: "Booze",
      label: "Booze",
      icon: "/assets/imgs/perks/options/booze.png",
    },
    {
      id: "Narcotics",
      label: "Narcotics",
      icon: "/assets/imgs/perks/options/narcotics.png",
    },
    {
      id: "KillSkill",
      label: "Kill skill",
      icon: "/assets/imgs/perks/options/killskill.png",
    },
    {
      id: "BustOut",
      label: "Bust out",
      icon: "/assets/imgs/perks/options/bustout.png",
    },
  ],
  cooldown: [
    {
      id: "Crime",
      label: "Crime",
      icon: "/assets/imgs/perks/options/crime.png",
    },
    {
      id: "NickCar",
      label: "Nick a car",
      icon: "/assets/imgs/perks/options/nickcar.png",
    },
    {
      id: "Booze",
      label: "Booze",
      icon: "/assets/imgs/perks/options/booze.png",
    },
    {
      id: "Narcotics",
      label: "Narcotics",
      icon: "/assets/imgs/perks/options/narcotics.png",
    },
    {
      id: "KillSkill",
      label: "Kill skill",
      icon: "/assets/imgs/perks/options/killskill.png",
    },
    {
      id: "Travel",
      label: "Travel",
      icon: "/assets/imgs/perks/options/travel.png",
    },
    {
      id: "BulletBuy",
      label: "Bullet Buy",
      icon: "/assets/imgs/perks/options/bulletbuy.png",
    },
    {
      id: "HealthBuy",
      label: "Health Buy",
      icon: "/assets/imgs/perks/options/healthbuy.png",
    },
    {
      id: "BustOut",
      label: "Bust out",
      icon: "/assets/imgs/perks/options/bustout.png",
    },
  ],
  booster: [
    {
      id: "MapYield",
      label: "Map Yield",
      icon: "/assets/imgs/perks/options/mapyield.png",
      property: "arrow-up",
    },
    {
      id: "RaceXp",
      label: "Race Xp",
      icon: "/assets/imgs/perks/options/racexp.png",
      property: "arrow-up",
    },
    {
      id: "KillSkillXp",
      label: "Kill Skill Xp",
      icon: "/assets/imgs/perks/options/killskill.png",
      property: "arrow-up",
    },
    {
      id: "BustOutXp",
      label: "Bust Out Xp",
      icon: "/assets/imgs/perks/options/bustout.png",
      property: "arrow-up",
    },
    {
      id: "SalesPriceNarcotics",
      label: "Sales Price",
      icon: "/assets/imgs/perks/options/narcotics.png",
      property: "arrow-up",
    },
    {
      id: "SalesPriceBooze",
      label: "Sales Price",
      icon: "/assets/imgs/perks/options/booze.png",
      property: "arrow-up",
    },
    {
      id: "Worth",
      label: "Worth",
      icon: "/assets/imgs/perks/options/worth.png",
      property: "arrow-up",
    },
    {
      id: "Rewards",
      label: "Crime Reward",
      icon: "/assets/imgs/perks/options/crime.png",
      property: "arrow-up",
    },
  ],
};

export const PERK_AMOUNT: Record<
  string,
  { id: string; label: string; icon: string; tag: string }[]
> = {
  success: [
    {
      id: "100",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/100.png",
    },
    {
      id: "75",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/75.png",
    },
    {
      id: "50",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/50.png",
    },
  ],
  cooldown: [
    {
      id: "90",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/90.png",
    },
    {
      id: "75",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/75.png",
    },
    {
      id: "50",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/50.png",
    },
  ],
  booster: [
    {
      id: "100",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/100.png",
    },
    {
      id: "75",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/75.png",
    },
    {
      id: "50",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/50.png",
    },
    {
      id: "25",
      label: "Amount",
      icon: "/assets/imgs/perks/amount/arrow-down.png",
      tag: "/assets/imgs/perks/amount/25.png",
    },
  ],
};

export const PERK_DURATION = [
  {
    id: "6",
    label: "Duration",
    icon: "/assets/imgs/perks/duration/clock.png",
    tag: "/assets/imgs/perks/duration/6.png",
  },
  {
    id: "12",
    label: "Duration",
    icon: "/assets/imgs/perks/duration/clock.png",
    tag: "/assets/imgs/perks/duration/12.png",
  },
  {
    id: "24",
    label: "Duration",
    icon: "/assets/imgs/perks/duration/clock.png",
    tag: "/assets/imgs/perks/duration/24.png",
  },
  {
    id: "48",
    label: "Duration",
    icon: "/assets/imgs/perks/duration/clock.png",
    tag: "/assets/imgs/perks/duration/48.png",
  },
  {
    id: "72",
    label: "Duration",
    icon: "/assets/imgs/perks/duration/clock.png",
    tag: "/assets/imgs/perks/duration/72.png",
  },
  {
    id: "96",
    label: "Duration",
    icon: "/assets/imgs/perks/duration/clock.png",
    tag: "/assets/imgs/perks/duration/96.png",
  },
];

export const PERK_TOOLS = [
  {
    id: "Purchase",
    label: "2x Purchase",
    icon: "/assets/imgs/perks/tools/purchase.png",
  },
  {
    id: "NoJail",
    label: "No Jail",
    icon: "/assets/imgs/perks/tools/no-jail.png",
  },
  {
    id: "FreeTravel",
    label: "Free Travel",
    icon: "/assets/imgs/perks/tools/travel.png",
  },
  {
    id: "BankFee",
    label: "Bank Fee 0%",
    icon: "/assets/imgs/perks/tools/bank-fee.png",
  },
  {
    id: "CreditCost",
    label: "-25% Credit Cost",
    icon: "/assets/imgs/perks/tools/credit-cost.png",
  },
  {
    id: "Convert",
    label: "20% Converter",
    icon: "/assets/imgs/perks/tools/convert.png",
  },
  {
    id: "CreditSpend",
    label: "-25% Credit Spend",
    icon: "/assets/imgs/perks/tools/credit-cost.png",
  },
];

export const PERK_CATEGORY_ID = {
  Crime: [18, 24, 40, 42],
  NickCar: [19, 25, 42],
  Booze: [20, 26, 38, 42],
  Narcotics: [21, 27, 37, 42],
  KillSkill: [22, 28, 35],
  BustOut: [23, 32, 36, 42],
  Travel: [29, 43],
  BulletBuy: [30, 41],
  HealthBuy: [31, 41],
  MapYield: [33],
  RaceXp: [34],
  Equipment: [39],
  Bank: [44],
  Credit: [45, 47],
  Convert: [46],
};

export const PERK_ITEM_INFO: {
  categoryId: number;
  type: string;
  name: string;
  description: string;
  icon: string;
}[] = [
  {
    categoryId: 18,
    type: "success",
    name: "Crime",
    description: "__value__% Success Chance",
    icon: "/assets/imgs/perks/options/crime.png",
  },
  {
    categoryId: 19,
    type: "success",
    name: "Nick a car",
    description: "__value__% Success Chance",
    icon: "/assets/imgs/perks/options/nickcar.png",
  },
  {
    categoryId: 20,
    type: "success",
    name: "Booze",
    description: "__value__% Success Chance",
    icon: "/assets/imgs/perks/options/booze.png",
  },
  {
    categoryId: 21,
    type: "success",
    name: "Narcotics",
    description: "__value__% Success Chance",
    icon: "/assets/imgs/perks/options/narcotics.png",
  },
  {
    categoryId: 22,
    type: "success",
    name: "Kill skill",
    description: "__value__% Success Chance",
    icon: "/assets/imgs/perks/options/killskill.png",
  },
  {
    categoryId: 23,
    type: "success",
    name: "Bust out",
    description: "__value__% Success Chance",
    icon: "/assets/imgs/perks/options/bustout.png",
  },
  {
    categoryId: 24,
    type: "cooldown",
    name: "Crime",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/crime.png",
  },
  {
    categoryId: 25,
    type: "cooldown",
    name: "Nick a car",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/nickcar.png",
  },
  {
    categoryId: 26,
    type: "cooldown",
    name: "Booze",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/booze.png",
  },
  {
    categoryId: 27,
    type: "cooldown",
    name: "Narcotics",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/narcotics.png",
  },
  {
    categoryId: 28,
    type: "cooldown",
    name: "Kill skill",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/killskill.png",
  },
  {
    categoryId: 29,
    type: "cooldown",
    name: "Travel",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/travel.png",
  },
  {
    categoryId: 30,
    type: "cooldown",
    name: "Bullet Buy",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/bulletbuy.png",
  },
  {
    categoryId: 31,
    type: "cooldown",
    name: "Health Buy",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/healthbuy.png",
  },
  {
    categoryId: 32,
    type: "cooldown",
    name: "Bust out",
    description: "-__value__% Cooldown",
    icon: "/assets/imgs/perks/options/bustout.png",
  },
  {
    categoryId: 33,
    type: "booster",
    name: "Map Yield",
    description: "__value__% Map Yield",
    icon: "/assets/imgs/perks/options/mapyield.png",
  },
  {
    categoryId: 34,
    type: "booster",
    name: "Race Xp",
    description: "__value__% Race XP",
    icon: "/assets/imgs/perks/options/racexp.png",
  },
  {
    categoryId: 35,
    type: "booster",
    name: "Kill Skill Xp",
    description: "__value__% Kill Skill XP",
    icon: "/assets/imgs/perks/options/killskill.png",
  },
  {
    categoryId: 36,
    type: "booster",
    name: "Bust Out Xp",
    description: "__value__% Bust Out XP",
    icon: "/assets/imgs/perks/options/bustout.png",
  },
  {
    categoryId: 37,
    type: "booster",
    name: "Sales Price",
    description: "+__value__% Sales Price",
    icon: "/assets/imgs/perks/options/narcotics.png",
  },
  {
    categoryId: 38,
    type: "booster",
    name: "Sales Price",
    description: "+__value__% Sales Price",
    icon: "/assets/imgs/perks/options/booze.png",
  },
  {
    categoryId: 39,
    type: "booster",
    name: "Worth",
    description: "+__value__% Worth",
    icon: "/assets/imgs/perks/options/worth.png",
  },
  {
    categoryId: 40,
    type: "booster",
    name: "Rewards",
    description: "+__value__% Crime Rewards",
    icon: "/assets/imgs/perks/options/crime.png",
  },
  {
    categoryId: 41,
    type: "tools",
    name: "Purchase",
    description: "2x Purchase",
    icon: "/assets/imgs/perks/tools/purchase.png",
  },
  {
    categoryId: 42,
    type: "tools",
    name: "No Jail",
    description: "No Jail",
    icon: "/assets/imgs/perks/tools/no-jail.png",
  },
  {
    categoryId: 43,
    type: "tools",
    name: "Free Travel",
    description: "Free Travel",
    icon: "/assets/imgs/perks/tools/travel.png",
  },
  {
    categoryId: 44,
    type: "tools",
    name: "Bank Fee",
    description: "No Bank Fee",
    icon: "/assets/imgs/perks/tools/bank-fee.png",
  },
  {
    categoryId: 45,
    type: "tools",
    name: "Credit Cost",
    description: "-25% Credit Cost",
    icon: "/assets/imgs/perks/tools/credit-cost.png",
  },
  {
    categoryId: 46,
    type: "tools",
    name: "Conversion rate",
    description: "20% Converter",
    icon: "/assets/imgs/perks/tools/convert.png",
  },
  {
    categoryId: 47,
    type: "tools",
    name: "Credit Spend",
    description: "-25% Credit Spend",
    icon: "/assets/imgs/perks/tools/credit-cost.png",
  },
];

export const PERK_HELPER_BOT_ALLOWED = {
  CRIME_SUCCESS_PERK_CATEGORY: 18,
  CRIME_COOLDOWN_PERK_CATEGORY: 24,
  CRIME_REWARDS_PERK_CATEGORY: 40,
  CRIME_CREDIT_COST_PERK_CATEGORY: 47,
  CAR_SUCCESS_PERK_CATEGORY: 19,
  CAR_COOLDOWN_PERK_CATEGORY: 25,
  CREDIT_COST_PERK_CATEGORY: 47,
  KILLSKILL_SUCCESS_PERK_CATEGORY: 22,
  KILLSKILL_COOLDOWN_PERK_CATEGORY: 28,
  BOOZE_SUCCESS_PERK_CATEGORY: 20,
  BOOZE_COOLDOWN_PERK_CATEGORY: 26,
  BOOZE_SALES_PRICE_PERK_CATEGORY: 38,
  NARCS_SUCCESS_PERK_CATEGORY: 21,
  NARCS_COOLDOWN_PERK_CATEGORY: 27,
  NARCS_SALES_PRICE_PERK_CATEGORY: 37,
  BULLET_COOLDOWN_PERK_CATEGORY: 30,
  BULLET_DOUBLE_PURCHASE_PERK_CATEGORY: 41,
};
